/**
 * Responsive sources for the photographs derived by `scripts/photos.mjs`.
 * Every derivative is named `<name>-<width>.<ext>` in `public/photos/`.
 */

/** Keep in step with `WIDTHS` in `scripts/photos.mjs`. */
const WIDTHS = [320, 512, 640, 768] as const;

/** The widest derivative — the `src` fallback, and what the sources top out at. */
const LARGEST = WIDTHS[WIDTHS.length - 1];

export type PhotoSources = {
  src: string;
  webp: string;
  jpeg: string;
};

const srcSet = (name: string, ext: string) =>
  WIDTHS.map((w) => `/photos/${name}-${w}.${ext} ${w}w`).join(', ');

export function photoSources(name: string): PhotoSources {
  return {
    src: `/photos/${name}-${LARGEST}.jpg`,
    webp: srcSet(name, 'webp'),
    jpeg: srcSet(name, 'jpg'),
  };
}
